import { useState } from "react";

import { apiRoot } from "../constants";

const useSubmission = () => {
  const [error, setError] = useState(false);

  const submitRestaurant = (data) => {
    return new Promise((res) => {
      fetch(`${apiRoot}/submissions`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (response.status !== 201) {
            setError(true);
            return;
          }
          return response.json();
        })
        .then((json) => {
          res(json);
        })
        .catch((err) => {
          setError(true);
        });
    });
  };

  return {
    submitRestaurant,
    error,
  };
};

export default useSubmission;
